export default __webpack_public_path__ + "static/media/mark.c4f15176.svg";